export interface TimeZoneConfiguration {
  id: string;
  displayname: string;
  timezoneid: string;
}

export const DEFAULT_TIME_ZONE = 'Etc/UTC';
